import { useEffect } from "react";
import { useState } from "react"

const useToken = user => {
    const [token, setToken] = useState('');

    useEffect(() => {
        const email = user?.user?.email;
        const currentUser = { email: email };

        const url = `${process.env.REACT_APP_API_BASE_URL}api/v1/bms/token/${email}`;

        if (email) {
            fetch(url, {
                method: 'POST',
                headers: {
                    'content-type': 'application/json'
                },
                body: JSON.stringify(currentUser)
            })
                .then(res => res.json())
                .then(data => {
                    if (data) {
                        const accessToken = data.token;
                        localStorage.setItem('accessToken', accessToken);
                        setToken(accessToken);
                    };
                });
        }

    }, [user]);
    return [token];
}

export default useToken;